var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component !== null)?_c(_vm.component.name,_vm._b({tag:"component"},'component',_vm.component.props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }